module.exports = __webpack_public_path__ + "static/media/DefaultGeneralBg-sm.150210b3.jpg";